<template>
  <div :class="{'ic-container-active': isSelected, 'ic-container': !isSelected}" @click="selectOption(enumValue)">
    <div class="ic">
      <div class="ic-icon">
        <slot name="left-icon" />
      </div>
      <p class="ic-title">
        {{ title }}
        <slot name="tooltip" />
      </p>
    </div>
    <div class="ic-circle">
      <div class="ic-inner-circle">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsuranceCard',
  props: {
    value: { required: false, type: Object },
    enumValue: { required: false, type: Object },
    title: {
      type: String,
    },
    person: {
      required: false,
      type: Object,
    },
  },
  methods: {
    selectOption(optionValue) {
      this.$emit('input', optionValue, this.person ? this.person : null);
    },
  },
  computed: {
    isSelected() {
      return this.value === this.enumValue;
    },
  },
};
</script>
